/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface PrinterStatusDTO
 */
export interface PrinterStatusDTOOptional {
  /**
   *
   * @type {number}
   * @memberof PrinterStatusDTO
   */
  statusCode?: number;
  /**
   *
   * @type {boolean}
   * @memberof PrinterStatusDTO
   */
  online?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PrinterStatusDTO
   */
  paperOut?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PrinterStatusDTO
   */
  coverOpen?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PrinterStatusDTO
   */
  drawerOpen?: boolean;
}

export interface PrinterStatusDTO extends PrinterStatusDTOOptional {
  /**
   *
   * @type {number}
   * @memberof PrinterStatusDTO
   */
  statusCode: number;
  /**
   *
   * @type {boolean}
   * @memberof PrinterStatusDTO
   */
  online: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PrinterStatusDTO
   */
  paperOut: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PrinterStatusDTO
   */
  coverOpen: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PrinterStatusDTO
   */
  drawerOpen: boolean;
}

export interface PrinterStatusDTOTrackedI {
  /**
   *
   * @type {number}
   * @memberof PrinterStatusDTO
   */
  statusCode?: number;
  statusCodeIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PrinterStatusDTO
   */
  online?: boolean;
  onlineIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PrinterStatusDTO
   */
  paperOut?: boolean;
  paperOutIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PrinterStatusDTO
   */
  coverOpen?: boolean;
  coverOpenIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PrinterStatusDTO
   */
  drawerOpen?: boolean;
  drawerOpenIsSet: boolean;
}

transformDatesMap.set(
  "PrinterStatusDTO",
  function (model: PrinterStatusDTO) {},
);

export type PrinterStatusDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  statusCode: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  online: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  paperOut: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  coverOpen: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  drawerOpen: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var PrinterStatusDTOMeta: PrinterStatusDTOMetaI =
  {} as PrinterStatusDTOMetaI;
PrinterStatusDTOMeta = typeMeta("PrinterStatusDTO", {
  statusCode: propertyMeta(
    "statusCode",
    false,
    true,
    false,
    MetaTypesBase.number,
  ),
  online: propertyMeta("online", false, true, false, MetaTypesBase.boolean),
  paperOut: propertyMeta("paperOut", false, true, false, MetaTypesBase.boolean),
  coverOpen: propertyMeta(
    "coverOpen",
    false,
    true,
    false,
    MetaTypesBase.boolean,
  ),
  drawerOpen: propertyMeta(
    "drawerOpen",
    false,
    true,
    false,
    MetaTypesBase.boolean,
  ),
});

const metaI = PrinterStatusDTOMeta;

registerMeta(() => {});

export class PrinterStatusDTOTracked implements PrinterStatusDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  statusCode__I?: number = undefined;
  statusCodeIsSet: boolean = false;
  set statusCode(v: undefined | number) {
    if (v !== undefined) {
      this.statusCode__I = v;
      this.statusCodeIsSet = true;
    } else {
      this.statusCode__I = v || undefined;
      this.statusCodeIsSet = true;
    }
    this.changeTracker = true;
  }
  get statusCode() {
    return this.statusCode__I;
  }
  online__I?: boolean = undefined;
  onlineIsSet: boolean = false;
  set online(v: undefined | boolean) {
    if (v !== undefined) {
      this.online__I = v;
      this.onlineIsSet = true;
    } else {
      this.online__I = v || undefined;
      this.onlineIsSet = true;
    }
    this.changeTracker = true;
  }
  get online() {
    return this.online__I;
  }
  paperOut__I?: boolean = undefined;
  paperOutIsSet: boolean = false;
  set paperOut(v: undefined | boolean) {
    if (v !== undefined) {
      this.paperOut__I = v;
      this.paperOutIsSet = true;
    } else {
      this.paperOut__I = v || undefined;
      this.paperOutIsSet = true;
    }
    this.changeTracker = true;
  }
  get paperOut() {
    return this.paperOut__I;
  }
  coverOpen__I?: boolean = undefined;
  coverOpenIsSet: boolean = false;
  set coverOpen(v: undefined | boolean) {
    if (v !== undefined) {
      this.coverOpen__I = v;
      this.coverOpenIsSet = true;
    } else {
      this.coverOpen__I = v || undefined;
      this.coverOpenIsSet = true;
    }
    this.changeTracker = true;
  }
  get coverOpen() {
    return this.coverOpen__I;
  }
  drawerOpen__I?: boolean = undefined;
  drawerOpenIsSet: boolean = false;
  set drawerOpen(v: undefined | boolean) {
    if (v !== undefined) {
      this.drawerOpen__I = v;
      this.drawerOpenIsSet = true;
    } else {
      this.drawerOpen__I = v || undefined;
      this.drawerOpenIsSet = true;
    }
    this.changeTracker = true;
  }
  get drawerOpen() {
    return this.drawerOpen__I;
  }
  constructor(config?: PrinterStatusDTOOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: PrinterStatusDTOOptional,
    options?: AssignOptions,
  ): PrinterStatusDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.statusCode &&
      this.statusCodeApplyFilter(optionsRequired.filter)
    ) {
      this.statusCode = config.statusCode;
      if (optionsRequired.unassign) this.statusCodeIsSet = false;
      else this.statusCodeIsSet = true;
    }
    if (config.online && this.onlineApplyFilter(optionsRequired.filter)) {
      this.online = config.online;
      if (optionsRequired.unassign) this.onlineIsSet = false;
      else this.onlineIsSet = true;
    }
    if (config.paperOut && this.paperOutApplyFilter(optionsRequired.filter)) {
      this.paperOut = config.paperOut;
      if (optionsRequired.unassign) this.paperOutIsSet = false;
      else this.paperOutIsSet = true;
    }
    if (config.coverOpen && this.coverOpenApplyFilter(optionsRequired.filter)) {
      this.coverOpen = config.coverOpen;
      if (optionsRequired.unassign) this.coverOpenIsSet = false;
      else this.coverOpenIsSet = true;
    }
    if (
      config.drawerOpen &&
      this.drawerOpenApplyFilter(optionsRequired.filter)
    ) {
      this.drawerOpen = config.drawerOpen;
      if (optionsRequired.unassign) this.drawerOpenIsSet = false;
      else this.drawerOpenIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PrinterStatusDTOTrackedI {
    const cloned = {} as PrinterStatusDTOTrackedI;
    if (
      this.statusCodeIsSetDeep() &&
      this.statusCodeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.statusCodeIsSet = true;
      cloned.statusCode = this.statusCode;
    } else {
      //cloned.statusCodeIsSet = false
    }
    if (
      this.onlineIsSetDeep() &&
      this.onlineApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.onlineIsSet = true;
      cloned.online = this.online;
    } else {
      //cloned.onlineIsSet = false
    }
    if (
      this.paperOutIsSetDeep() &&
      this.paperOutApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paperOutIsSet = true;
      cloned.paperOut = this.paperOut;
    } else {
      //cloned.paperOutIsSet = false
    }
    if (
      this.coverOpenIsSetDeep() &&
      this.coverOpenApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.coverOpenIsSet = true;
      cloned.coverOpen = this.coverOpen;
    } else {
      //cloned.coverOpenIsSet = false
    }
    if (
      this.drawerOpenIsSetDeep() &&
      this.drawerOpenApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.drawerOpenIsSet = true;
      cloned.drawerOpen = this.drawerOpen;
    } else {
      //cloned.drawerOpenIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PrinterStatusDTOTrackedI {
    if (!this.statusCodeApplyFilter(filter)) this.statusCodeIsSet = false;

    if (!this.onlineApplyFilter(filter)) this.onlineIsSet = false;

    if (!this.paperOutApplyFilter(filter)) this.paperOutIsSet = false;

    if (!this.coverOpenApplyFilter(filter)) this.coverOpenIsSet = false;

    if (!this.drawerOpenApplyFilter(filter)) this.drawerOpenIsSet = false;

    return this;
  }
  statusCodeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PrinterStatusDTOMeta.statusCode,
      PrinterStatusDTOMeta,
      this.statusCode,
      this,
    );
  }
  statusCodeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.statusCodeIsSet && this.statusCodeApplyFilter(filter)) return true;

    return false;
  }
  onlineApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PrinterStatusDTOMeta.online,
      PrinterStatusDTOMeta,
      this.online,
      this,
    );
  }
  onlineIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.onlineIsSet && this.onlineApplyFilter(filter)) return true;

    return false;
  }
  paperOutApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PrinterStatusDTOMeta.paperOut,
      PrinterStatusDTOMeta,
      this.paperOut,
      this,
    );
  }
  paperOutIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paperOutIsSet && this.paperOutApplyFilter(filter)) return true;

    return false;
  }
  coverOpenApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PrinterStatusDTOMeta.coverOpen,
      PrinterStatusDTOMeta,
      this.coverOpen,
      this,
    );
  }
  coverOpenIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.coverOpenIsSet && this.coverOpenApplyFilter(filter)) return true;

    return false;
  }
  drawerOpenApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PrinterStatusDTOMeta.drawerOpen,
      PrinterStatusDTOMeta,
      this.drawerOpen,
      this,
    );
  }
  drawerOpenIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.drawerOpenIsSet && this.drawerOpenApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.statusCodeIsSetDeep(filter)) return true;
    if (this.onlineIsSetDeep(filter)) return true;
    if (this.paperOutIsSetDeep(filter)) return true;
    if (this.coverOpenIsSetDeep(filter)) return true;
    if (this.drawerOpenIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
